import { render, staticRenderFns } from "./SpiritualLarge.vue?vue&type=template&id=6a044dc8&"
import script from "./SpiritualLarge.vue?vue&type=script&lang=js&"
export * from "./SpiritualLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports